var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { generateReducer } from "../generators/generator.reducer";
import { performExternalActionStart, performExternalActionSucceeded, performExternalActionFailed, } from "./externalAction.actions";
import { GENERATOR_PARAMS } from "./externalAction.constants";
var getExtraDefaultState = function () { return ({
    externalAction: {},
}); };
var _reducer = generateReducer(GENERATOR_PARAMS, getExtraDefaultState);
var reducer = _reducer;
reducer.on(performExternalActionStart.type, function (state, _a) {
    var _b;
    var type = _a.type;
    return __assign(__assign({}, state), { externalAction: __assign(__assign({}, state.externalAction), (_b = {}, _b[type] = __assign(__assign({}, state.externalAction[type]), { isPending: true, error: undefined }), _b)) });
});
reducer.on(performExternalActionSucceeded.type, function (state, _a) {
    var _b;
    var type = _a.type;
    return __assign(__assign({}, state), { externalAction: __assign(__assign({}, state.externalAction), (_b = {}, _b[type] = __assign(__assign({}, state.externalAction[type]), { isPending: false, error: undefined }), _b)) });
});
reducer.on(performExternalActionFailed.type, function (state, _a) {
    var _b;
    var type = _a.type, error = _a.error;
    return __assign(__assign({}, state), { externalAction: __assign(__assign({}, state.externalAction), (_b = {}, _b[type] = __assign(__assign({}, state.externalAction[type]), { isPending: false, error: error }), _b)) });
});
// eslint-disable-next-line import/no-default-export
export default reducer;
